import script from "./JoinMeetingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinMeetingModal.vue?vue&type=script&setup=true&lang=js"

import "./JoinMeetingModal.vue?vue&type=style&index=0&id=49775c86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49775c86"]])

export default __exports__